import React, { CSSProperties } from 'react';

import { ErrorMessage, FieldProps } from 'formik';

import { styled } from '../theme';
import FormGroup from './FormGroup';
import Toggle from './Toggle';

const Container = styled('div')(({ theme }) => ({
    paddingTop: 15,
    cursor: 'pointer',
}));

type Props = {
    name: string;
    mapNameToLabel: (name: string) => string;
    value: boolean;
    onChange: (value: boolean) => void;
    autoFocus?: boolean;
    componentStyle?: CSSProperties;
};

const FormikToggle: React.FC<Props & FieldProps<any>> = ({
    field,
    form,
    mapNameToLabel,
    componentStyle,
    ...props
}) => (
    <FormGroup>
        <Container
            style={componentStyle}
            onClick={() => {
                form.setTouched({ ...form.touched, [field.name]: true });
                form.setValues({ ...form.values, [field.name]: !field.value });
            }}
        >
            <Toggle style={{ pointerEvents: 'none' }} checked={field.value} readOnly />
            <span>{mapNameToLabel(field.name)}</span>
        </Container>
        <ErrorMessage name={field.name} />
    </FormGroup>
);

export default FormikToggle;
